<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-wrapper">
      <button @click="close" class="modal-close">×</button>
      <div class="modal-body">
        <div id="modal-online-scheduling">
          <page-online-scheduling :dealer-id="dealerId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import pageOnlineScheduling from '../../pages/online-scheduling.vue';
import store from "../../store";
import { mapActions } from "vuex";

export default {
  components: {
    pageOnlineScheduling,
  },
  props: {
    dealerId: {
      type: String,
      required: true,
    }
  },
  methods: {
    ...mapActions('OnlineScheduling', { resetData: 'resetData' }),
    close() {
      const el = document.querySelector('.modal-overlay');
      if (el) el.remove();
      document.body.style.overflow = '';
      this.resetData();
    }
  },

  open(props = {}) {
    let el = document.createElement('div');
    document.body.appendChild(el);

    const ModalClass = Vue.extend(this);
    const modalInstance = new ModalClass({
      store,
      propsData: props,
    });

    // Allow internal close to remove modal
    modalInstance.$on('close', () => {
      modalInstance.$destroy();
      // modal element itself is removed by the close() method
    });

    modalInstance.$mount(el);
    document.body.style.overflow = 'hidden';

    return modalInstance;
  }
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0; 
  left: 0; 
  right: 0; 
  bottom: 0;
  background: rgba(6,88,148,0.8)!important;
  z-index: 10000;
  display: flex;
  justify-content: center;
  padding: 2rem;
}
.modal-wrapper {
  display: flex;
  flex-direction: column;
  background: white;
  padding: 20px;
  position: relative;
  width:100%;
  max-width: 64rem;
  margin: auto 0;
  max-height: 90vh;
}
.modal-close {
  position: absolute;
  top: .5rem;
  right: 1rem;
  margin-left: auto;
  font-size: 3rem;
  border: none;
  background: none;
  cursor: pointer;
  color: #e5231b;
  height: 2rem;
  line-height: 1;
  z-index: 2;
  transition: ease .35s;
  &:hover {
    transform: scale(1.1);
  }
}
.modal-body {
  flex: 1;
  overflow-y: auto;
}
</style>
